export default "__VITE_ASSET__CU52I2Nd__"